import React, { useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Popover } from 'react-tiny-popover';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../components/bootstrap/OffCanvas';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import Icon from '../../components/icon/Icon';
import PlaceholderImage from '../../components/extras/PlaceholderImage';
import PaginationButtons, { PER_COUNT } from '../../components/PaginationButtonsdb';
import useSortableData from '../../hooks/useSortableData';
import useDarkMode from '../../hooks/useDarkMode';
import Select from '../../components/bootstrap/forms/Select';
import { userAuth } from '../../contexts/userContext';
import { multiinputcheck, nameRegex, priceRegex } from './vhelper/val';
import { numberRegex } from './vhelper/val';
import { nicRegex } from './vhelper/val';
import { zipRegex } from './vhelper/val';
import { charRegex } from './vhelper/val';
import { Ralert } from './vhelper/Normarodallalert';
import CountryFlagWithPhoneCodeSelector from './vhelper/flag';
import './vhelper/flag.css';
import UpCountryFlagWithPhoneCodeSelector from './vhelper/upflag';
import apiService from '../../api/apiService';
import CommonActionHeader from './Headers/commonActionHeader';
import Textarea from '../../components/bootstrap/forms/Textarea';
import CommonAPIService from '../../api/CommonAPIService';
import CustomDatePicker from '../presentation/demo-pages/helper/CustomDatePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { CommonImgCompresser } from './vhelper/common_img_compresser';
import { CommonCropperModal } from './vhelper/commonCropperModal';
import { useTranslation } from 'react-i18next';
import NoRecords from './vhelper/emptytbl';
import Label from '../../components/bootstrap/forms/Label';
import Checks, { ChecksGroup } from '../../components/bootstrap/forms/Checks';
import '../common/procss.css';
import CustomSearchInput from '../presentation/demo-pages/helper/CustomSearchInput';
dayjs.extend(customParseFormat);

const CommonProductList = ({ isFluid }) => {
	const { t } = useTranslation();
	const { darkModeStatus, themeStatus } = useDarkMode();

	const [upcomingEventsEditOffcanvas, setUpcomingEventsEditOffcanvas] = useState(false);

	const [upcomingEventsEditOffcanvasp, setUpcomingEventsEditOffcanvasp] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(PER_COUNT['25']);
	const [totalRows, settotalRows] = useState(25);
	const controllerRef = useRef(null);
	const [promo, setPromo] = useState([]);
	const [promoc, setPromoc] = useState('');
	const { items } = useSortableData(promo);
	const [progress, setProgress] = useState({ uploading: false, progress: 0 });
	const [udetail, setudetail] = useState({});

	const [condialog, setCondialog] = useState(false);

	const [imgtypeerror, setImgtypeerror] = useState(false);
	const [imgedittypeerror, setImgedittypeerror] = useState(false);

	const [isCropperModalOpen, setCropperModalOpen] = useState(false);
	const [isEditCropperModalOpen, setEditCropperModalOpen] = useState(false);
	const compresserRef = useRef(null);
	const [imgFile, setImgFile] = useState(null);
	const inputFile = useRef(null);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const [imgurl, setImgurl] = useState(null);
	const [setFilepath] = useState('');
	const [qparam] = useSearchParams();
	const APIService = CommonAPIService();

	const [upcheckinputerror, setUpcheckinputerror] = useState({});
	const [newcheckinputerror, setNewcheckinputerror] = useState({});

	const [selectall, setSelectall] = useState({
		id: 'All',
		label: t('Select All'),
		checked: false,
	});

	const [selectalle, setSelectalle] = useState({
		id: 'All',
		label: t('Select All'),
		checked: false,
	});

	const [searchValue, setSearchValue] = useState('');
	const [isMobile, setIsMobile] = useState(false);
	const [isTab, setIsTab] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 782);
			setIsTab(window.innerWidth > 782 && window.innerWidth <= 1428);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const phpUp = async (files) => {
		if (!files) {
			alert(t('Please select a file!'));
			return false;
		}
		const data = new FormData();

		for (let i = 0; i < files.length; i++) {
			data.append(`product[${i}]`, files[i]);
		}
		const upload_URL = process.env.REACT_APP_IMG_UPLOAD_LINK;

		resetUpload();
		controllerRef.current = new AbortController();
		setProgress({ uploading: true, progress: 0 });

		axios
			.post(upload_URL, data, {
				// receive two parameter endpoint url ,form data
				signal: controllerRef.current.signal,
				onUploadProgress: (progressEvent) => {
					const progress = (progressEvent.loaded / progressEvent.total) * 100;
					setProgress((pre) => {
						return { ...pre, progress: progress };
					});
				},
			})
			.then(
				(res) => {
					// then print response status
					// this.setState({ responseArray: res.data });
					// this.resetFile();
					//
					setImgurl(res.data.url);
					// const imgdata = new FormData();
					// imgdata.append('service_img', [res.data.url])
					setProgress({ uploading: false, progress: 0 });
				},
				(error) => {
					if (error.code) {
						if (error.code === 'ERR_CANCELED') {
						} else {
							alert(error);
						}
					} else {
						alert(error);
					}
					setProgress({ uploading: false, progress: 0 });
					setImgurl(null);
					handleReset();
				},
			);
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
			setIsMobile(window.innerWidth <= 600);
			setIsTab(window.innerWidth > 601 && window.innerWidth <= 1428);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// upemp img up
	const phpempUp = async (files) => {
		if (!files) {
			alert(t('Please select a file!'));
			return false;
		}
		const data = new FormData();

		for (let i = 0; i < files.length; i++) {
			data.append(`employee[${i}]`, files[i]);
		}
		//
		const upload_URL = process.env.REACT_APP_IMG_UPLOAD_LINK;
		//let url = 'https://business.schedulerdesk.com/upload_emp.php';

		resetUpload();
		controllerRef.current = new AbortController();
		setProgress({ uploading: true, progress: 0 });

		axios
			.post(upload_URL, data, {
				// receive two parameter endpoint url ,form data
				signal: controllerRef.current.signal,
				onUploadProgress: (progressEvent) => {
					const progress = (progressEvent.loaded / progressEvent.total) * 100;
					setProgress((pre) => {
						return { ...pre, progress: progress };
					});
				},
			})
			.then(
				(res) => {
					// setImgurlup(res.data.url);
					setudetail((pre) => {
						const temp = {
							...pre,
							filepath: res.data.url,
						};
						return temp;
					});
					setProgress({ uploading: false, progress: 0 });
				},
				(error) => {
					if (error.code) {
						if (error.code === 'ERR_CANCELED') {
						} else {
							alert(error);
						}
					} else {
						alert(error);
					}
					setProgress({ uploading: false, progress: 0 });
					setudetail((pre) => {
						const temp = {
							...pre,
							filepath: '',
						};
						return temp;
					});
					setImgurl(null);
					handleReset();
					setImgedittypeerror(false);
				},
			);
	};

	//cancel upload if uploading
	const resetUpload = () => {
		//
		setProgress((pre) => {
			return { uploading: false, progress: 0 };
		});
		if (controllerRef.current) controllerRef.current.abort();
		controllerRef.current = null;
	};

	const [upcomingEventsInfoOffcanvasss, setUpcomingEventsInfoOffcanvasss] = useState(false);
	const handleUpcomingDetailsss = () => {
		setUpcomingEventsInfoOffcanvasss(!upcomingEventsInfoOffcanvasss);
		setNewemperror({
			Name: { error: false, msg: t('*Required') },
			Proprice: { error: false, msg: t('*Required') },
			Branch: { error: false, msg: t('*Required') },
			Show: { error: false, msg: t('*Required') },
			Note: { error: false, msg: t('*Required') },
		});
		setBranches((p) => p.map((r) => ({ ...r, checked: false, qty: '', minqty: '' })));
	};

	const [epw, setEpw] = useState('');

	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	const [newemp, setNewemp] = useState({});

	const [branches, setBranches] = useState([]);
	const [branch, setbranch] = useState({ error: false, msg: t('*Required'), data: '' });
	const [branchess, setBranchess] = useState([]);
	const [branchh, setbranchh] = useState({ error: false, msg: t('*Required'), data: '' });

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_branches_list' };

			const flechdata = await apiService(item, token, setToken, navigate);
			if (Array.isArray(flechdata.data)) {
				const temp = flechdata.data.map((ele) => ({
					id: ele.branch_id,
					value: ele.branch_id,
					label: ele.branch_name,
					checked: false,
					qty: '',
					minqty: '',
				}));
				setBranches(temp);
				setBranchess(temp);

				localStorage.setItem('branches-list', JSON.stringify(temp));
			} else {
				localStorage.removeItem('branches-list');
			}
		};

		const storedBranches = localStorage.getItem('branches-list');
		if (storedBranches !== null) {
			const formattedBranches = JSON.parse(storedBranches);
			if (Array.isArray(formattedBranches)) {
				setBranches(
					formattedBranches.map((d) => ({
						id: d.value,
						value: d.value,
						label: d.text,
						checked: false,
						qty: '',
						minqty: '',
					})),
				);
				setBranchess(
					formattedBranches.map((d) => ({
						id: d.value,
						value: d.value,
						label: d.text,
						checked: false,
						qty: '',
						minqty: '',
					})),
				);
			} else {
				fetchata();
			}
		}
	}, []);

	const [newemperror, setNewemperror] = useState({
		Name: { error: false, msg: t('*Required') },
		Proprice: { error: false, msg: t('*Required') },
		Branch: { error: false, msg: t('*Required') },
		Show: { error: false, msg: t('*Required') },
		Note: { error: false, msg: t('*Required') },
	});

	const [updateemployeeerror, setUpdateemployeeerror] = useState({
		name: { error: false, msg: t('*Required') },
		price: { error: false, msg: t('*Required') },
		show_customer: { error: false, msg: t('*Required') },
		pro_sts: { error: false, msg: t('*Required') },
		description: { error: false, msg: t('*Required') },
	});

	const handleCountrySelect = (selectedCountry) => {
		setNewemp((pre) => {
			const temp = { ...pre };
			temp['Phonec'] = `${selectedCountry.phoneCode}`.substring(1);
			return temp;
		});

		setNewemperror((pre) => {
			const temp = {
				...pre,
				Phonec: {
					error: false,
					msg: t('*Required'),
				},
			};
			return temp;
		});
	};

	const upHandleCountrySelect = (selectedCountry) => {
		setudetail((pre) => {
			const temp = { ...pre };
			temp['phone_code'] = `${selectedCountry.phoneCode}`.substring(1);
			return temp;
		});
	};

	const togglePasswordVisibilitynew = (value) => {
		if (value) {
			setShowPasswordnew(value);
		} else {
			setShowPasswordnew(!showPasswordnew);
		}
	};

	/**employee site open in new tab*/
	const redirectToEmployeeSite = (adminLoginUserId) => {
		if (adminLoginUserId) {
			const url = `https://employee.schedulerdesk.com/customer_active?id=${adminLoginUserId}`;
			window.open(url, '_blank', 'noopener,noreferrer');
		}
	};

	const [isemptyedit12] = useState({ error: false, msg: t('*Required') });

	const [isemptyeditpwr, setIsemptyeditpwr] = useState({ error: false, msg: t('*Required') });

	const [loadtable, setLoadtable] = useState(false);

	const [loadalert, setLoadalert] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordnew, setShowPasswordnew] = useState(false);
	const [isPopoverOpen, setIsPopoverOpen] = useState([]);
	const [isPopoverOpenlow, setIsPopoverOpenlow] = useState([]);

	const currentDate = new Date().toISOString().split('T')[0];
	const maxSelectableDate = dayjs(currentDate).subtract(1, 'day');
	const [isLoading, setIsLoading] = useState(false);

	const insertProduct = async () => {
		if (isLoading) return;
		let cansendapi = multiinputcheck(
			['Name', 'Proprice', 'Note', 'Show'],
			newemp,
			setNewemperror,
			{
				// Name: [nameRegex, t('Only characters accepted')],
				Proprice: [
					priceRegex,
					t('Only integers or decimals numbers with up to 2 decimal places accepted'),
				],
				// Quantity: [numberRegex, t('Only integers accepted')],
				// Minquantity: [numberRegex, t('Only integers accepted')],
			},
			t('*Required'),
		);

		if (cansendapi) {
			setIsLoading(true);
			const formData = {};
			// let phonecodeadd;
			// tableOptionc.forEach((ele) => {
			// 	if (ele.value === newemp.Phonec) {
			// 		phonecodeadd = ele.text;
			// 	}
			// });
			const filterbranch = branches.filter((branch) => branch.checked === true);
			formData['product_img'] = `["${imgurl}"]`;
			formData['product_name'] = newemp.Name;
			formData['price'] = newemp.Proprice;
			// formData['quantity'] = newemp.Quantity;
			// formData['min_quantity'] = newemp.Minquantity;
			formData['description'] = newemp.Note;
			formData['show_customer'] = newemp.Show;
			formData['inventory_data'] = JSON.stringify(
				filterbranch.map((p) => ({
					branch_id: p.id,
					quantity: p.qty,
					min_quantity: p.minqty,
				})),
			);

			formData['action'] = 'add_product';
			try {
				//const flechdata = await apiService(formData, token, setToken, navigate);
				const flechdata = await APIService.sendRequest(formData);

				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setNewemp({});
					setBranches((p) =>
						p.map((r) => ({ ...r, checked: false, qty: '', minqty: '' })),
					);
					setUpcomingEventsInfoOffcanvasss(!upcomingEventsInfoOffcanvasss);
					setLoadtable(!loadtable);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				} else {
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const [tableOption, setTableOption] = useState([]);
	const [uptableOption, setUpTableOption] = useState([]);

	const [tableOptionc, setTableOptionc] = useState([]);
	const [uptableOptionc, setUpTableOptionc] = useState([]);

	useEffect(() => {
		if (qparam.get('search')) {
			filtersearch(qparam.get('search'));
		} else {
			if (branch.data) {
				filterapp(currentPage, perPage);
			}
		}
	}, [loadtable, qparam.get('search'), branch?.data]);

	useEffect(() => {
		filterapp(currentPage, perPage);
	}, []);

	const filterapp = async (pageid, dlimit) => {
		const item = {
			action: 'get_product_data',
			branch_id: branch.data || 'all',
			page_id: pageid,
			limit: dlimit,
		};
		try {
			//const flechdata = await apiService(item, token, setToken, navigate);
			const flechdata = await APIService.sendRequest(item);

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setPromo(flechdata.data);
				setPromoc(flechdata);
				settotalRows(flechdata.TotalRecords);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const handlefunction = (pagenumber, limit) => {
		const pagelimit = limit ? limit : perPage;
		if (searchValue) {
			filtersearch(searchValue, pagenumber, pagelimit);
		} else {
			filterapp(pagenumber, pagelimit);
		}
	};

	// search
	const filtersearch = async (sval, pagenumber, limit) => {
		const item = {
			action: 'get_product_data',
			branch_id: branch.data,
			page_id: pagenumber ? pagenumber : currentPage,
			limit: limit ? limit : perPage,
			search_value: sval,
		};

		try {
			//const flechdata = await apiService(item, token, setToken, navigate);
			const flechdata = await APIService.sendRequest(item);
			//

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setSearchValue(sval);
				setPromo(flechdata.data);
				setPromoc(flechdata);
				settotalRows(flechdata.TotalRecords);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// single emp data

	// edit

	const handleUpcomingEdit = (id) => {
		setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);

		setUpdateemployeeerror({
			name: { error: false, msg: t('*Required') },
			price: { error: false, msg: t('*Required') },
			show_customer: { error: false, msg: t('*Required') },
			status: { error: false, msg: t('*Required') },
			description: { error: false, msg: t('*Required') },
		});
		// const temp = promo.find((ele) => ele.id === id);
		// setudetail(temp);
		//
		setBranchess((p) => p.map((r) => ({ ...r, checked: false, qty: '', minqty: '' })));
		setSelectalle((pre) => {
			const tepmarray = { ...pre };
			tepmarray.checked = false;
			return tepmarray;
		});
		(async () => {
			const item = { action: 'get_single_product_data', product_id: id };
			//const flechdata = await apiService(item, token, setToken, navigate);
			try {
				const flechdata = await APIService.sendRequest(item);
				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setudetail(flechdata.data[0]);
					if (Array.isArray(flechdata.data[0].inventory_data)) {
						setBranchess((p) => {
							const temp = [...p];
							const setdata = temp.map((r) => {
								const apidata = flechdata.data[0].inventory_data.filter(
									(a) => a.branch_id == r.id,
								);
								if (apidata.length > 0) {
									r.qty = apidata[0].quantity;
									r.minqty = apidata[0].min_quantity;
									r.checked = true;

									return r;
								}
								return r;
							});
							return setdata;
						});
					}
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		})();
	};

	const selectpcode = (pcode) => {
		const phone_code = uptableOptionc.find((d) => d.phoneCode === `+${pcode}`);
		if (phone_code?.phoneCode) return phone_code;
		else return '';
	};

	// update
	const updateproduct = async () => {
		if (isLoading) return;
		const cansendapi = multiinputcheck(
			['name', 'price', 'status', 'description'],
			udetail,
			setUpdateemployeeerror,
			{
				// name: [nameRegex, t('Only characters accepted')],
				price: [priceRegex, t('Only characters accepted')],
			},
			t('*Required'),
		);
		if (cansendapi) {
			setIsLoading(true);
			const formData = {};
			//const filterbranch = branchess.filter((branch) => branch.checked === true);
			formData['product_img'] = `["${udetail.filepath}"]`;
			formData['product_name'] = udetail.name;
			formData['price'] = udetail.price;
			// formData['quantity'] = udetail.quantity;
			// formData['min_quantity'] = udetail.min_quantity;
			formData['description'] = udetail.description;
			formData['show_customer'] = udetail.show_customer;
			formData['inventory_data'] = JSON.stringify(
				branchess.map((r) => ({
					branch_id: r.id,
					quantity: r.qty,
					min_quantity: r.minqty,
					status: r.checked,
				})),
			);
			// formData['inventory_data'] = JSON.stringify(
			// 	filterbranch.map((r) => ({
			// 		branch_id: r.id,
			// 		quantity: r.qty,
			// 		min_quantity: r.minqty,
			// 		status: 1,
			// 	})),
			// );
			formData['status'] = udetail.status;

			formData['action'] = 'update_product';
			formData['product_id'] = udetail.id;

			//const flechdata = await apiService(formData, token, setToken, navigate);
			try {
				const flechdata = await APIService.sendRequest(formData);
				//

				if (flechdata.type === 'Success' || flechdata.type === 'success') {
					setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);
					setBranchess((p) =>
						p.map((r) => ({ ...r, checked: false, qty: '', minqty: '' })),
					);
					setLoadtable(!loadtable);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				} else {
					// setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);
					startmodel();
					setMsgLoadalert(flechdata.message);
					setMsgtypeLoadalert(flechdata.type);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	// Function to reset the input element
	const handleReset = () => {
		if (inputFile.current) {
			inputFile.current.value = '';
			inputFile.current.type = 'text';
			inputFile.current.type = 'file';
		}
	};

	const closemodel = () => {
		setLoadalert(false);
	};
	const startmodel = () => {
		setLoadalert(true);
	};

	// confirm dailog
	const closemodel2 = () => {
		setCondialog(false);
		// setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);
		// setChangests(!changests);
		setudetail((pre) => {
			const temp = {
				...pre,
				estatus: '1',
			};
			return temp;
		});
	};
	const closemodel3 = () => {
		setCondialog(false);
		// setUpcomingEventsEditOffcanvas(!upcomingEventsEditOffcanvas);
	};
	const startmodel2 = () => {
		setCondialog(true);
	};

	const addCompressSingle = () => {
		if (compresserRef.current) {
			compresserRef.current.abort();
			compresserRef.current = new AbortController();
		} else {
			compresserRef.current = new AbortController();
		}
	};

	return (
		<>
			<Ralert
				msgloadalert={msgloadalert}
				msgtypeloadalert={msgtypeloadalert}
				loadalert={loadalert}
				closemodel={closemodel}
			/>

			<CommonCropperModal
				isOpen={isCropperModalOpen}
				setOpen={setCropperModalOpen}
				imgFile={imgFile}
				cropShape={'round'}
				onCloseModal={() => {
					if (compresserRef.current) {
						compresserRef.current.abort();
					}
					setImgurl(null);
					handleReset();
				}}
				aspectRatio={1 / 1}
				objectFit={'contain'}
				onComplete={async (croppedImage, file) => {
					addCompressSingle();
					setProgress({ uploading: true, progress: 0 });
					const options = {
						maxSizeMB: 1,
						maxWidthOrHeight: 1920,
						useWebWorker: true,
						signal: compresserRef.current.signal,
					};
					await CommonImgCompresser(file, options)
						.then((blobFile) => {
							if (blobFile) {
								//
								phpUp([blobFile]);
							} else {
								setProgress({ uploading: false, progress: 0 });
								setImgurl(null);
								handleReset();
							}
						})
						.catch((error) => {
							setProgress({ uploading: false, progress: 0 });
							setImgurl(null);
							handleReset();
						});
				}}
				img={imgurl}
				setImg={setImgurl}
			/>

			<CommonCropperModal
				isOpen={isEditCropperModalOpen}
				setOpen={setEditCropperModalOpen}
				imgFile={imgFile}
				cropShape={'round'}
				onCloseModal={() => {
					if (compresserRef.current) {
						compresserRef.current.abort();
					}
					setProgress({ uploading: false, progress: 0 });
					setudetail((pre) => {
						const temp = {
							...pre,
							filepath: '',
						};
						return temp;
					});
					setImgurl(null);
					handleReset();
					setImgedittypeerror(false);
				}}
				aspectRatio={1 / 1}
				objectFit={'contain'}
				onComplete={async (croppedImage, file) => {
					addCompressSingle();
					setudetail((pre) => {
						const temp = {
							...pre,
							filepath: croppedImage,
						};
						return temp;
					});
					setProgress({ uploading: true, progress: 0 });
					const options = {
						maxSizeMB: 1,
						maxWidthOrHeight: 1920,
						useWebWorker: true,
						signal: compresserRef.current.signal,
					};

					await CommonImgCompresser(file, options)
						.then((blobFile) => {
							if (blobFile) {
								//
								phpempUp([blobFile]);
							} else {
								setProgress({ uploading: false, progress: 0 });
								setudetail((pre) => {
									const temp = {
										...pre,
										filepath: '',
									};
									return temp;
								});
								setImgurl(null);
								handleReset();
								setImgedittypeerror(false);
							}
						})
						.catch((error) => {
							setProgress({ uploading: false, progress: 0 });
							setudetail((pre) => {
								const temp = {
									...pre,
									filepath: '',
								};
								return temp;
							});
							setImgurl(null);
							handleReset();
							setImgedittypeerror(false);
						});
				}}
				img={imgurl}
				setImg={setImgurl}
			/>

			<Ralert
				msgloadalert={
					udetail.estatus === '0'
						? t('Are you sure you want to DEACTIVATE this Product?')
						: t('Are you sure you want to ACTIVATE this Product?')
				}
				msgtypeloadalert={t('Are you sure?')}
				msgsmtext={
					udetail.estatus === '0' &&
					`${t('Important Notice')}': ${t(
						'Jobs assigned to this employee will be disabled directly',
					)}.`
				}
				loadalert={condialog}
				closemodel={closemodel2}
				confirmbt={closemodel3}
			/>
			<div className='row mb-4'>
				<div className='col-auto'>
					<CardLabel icon='Inventory' iconColor='info'>
						<CardTitle tag='h3'>{t('Products')}</CardTitle>
					</CardLabel>
				</div>

				<div className='col-auto me-auto'>
					<div className='d-flex' style={{ height: '100%' }}>
						<div className='vr visually-hidden' />
					</div>
				</div>

				<div className='col-auto me-3 align-self-end'>
					<Button
						icon='Add'
						color='primary'
						isLight
						onClick={() => handleUpcomingDetailsss(true)}>
						{t('New Product')}
					</Button>
				</div>
			</div>
			<Card stretch={isFluid}>
				<CardHeader borderSize={1}>
					<div className='row g-3 w-100' style={{ marginBottom: '15px' }}>
						{isTab ? (
							<>
								<div className='row g-3'>
									<div className='col-auto'>
										<FormGroup id='btype' label={t('Branch')}>
											<Select
												placeholder={t('Select')}
												// value={branch.data}
												// list={branches}
												value={
													branch.data ||
													(branches.length > 0 ? 'all' : '')
												}
												list={
													branches.length > 0
														? [
																{ value: 'all', label: 'All' },
																...branches,
														  ]
														: []
												}
												style={{
													border: branch.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												onChange={(e) => {
													if (branch.error) {
														setbranch((pre) => ({
															...pre,
															error: false,
														}));
													}
													setbranch((pre) => ({
														...pre,
														data: e.target.value,
													}));
												}}
											/>
										</FormGroup>
										{branch.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{branch.msg ? branch.msg : t('*Required')}
											</p>
										)}
									</div>

									<div className='col-auto ms-auto mt-2'>
										<CustomSearchInput
											mobileWidth='100%'
											onSearch={(value) => {
												filtersearch(value);
											}}
											// clearTrigger={clearTrigger}
										/>
									</div>
								</div>
							</>
						) : (
							<>
								<div className='col-12 col-md-auto'>
									<FormGroup id='btype' label={t('Branch')}>
										<Select
											placeholder={t('Select')}
											// value={branch.data}
											// list={branches}
											value={
												branch.data || (branches.length > 0 ? 'all' : '')
											}
											list={
												branches.length > 0
													? [{ value: 'all', label: 'All' }, ...branches]
													: []
											}
											style={{
												border: branch.error
													? '2px solid red'
													: '2px solid transparent',
											}}
											onChange={(e) => {
												if (branch.error) {
													setbranch((pre) => ({
														...pre,
														error: false,
													}));
												}
												setbranch((pre) => ({
													...pre,
													data: e.target.value,
												}));
											}}
										/>
									</FormGroup>
									{branch.error && (
										<p
											style={{
												color: 'red',
												fontSize: '12px',
											}}>
											{' '}
											{branch.msg ? branch.msg : t('*Required')}
										</p>
									)}
								</div>

								<CardActions
									className={
										isMobile ? '' : 'col-auto ms-auto row align-items-center'
									}
									style={{
										marginTop: isMobile ? '24px' : '30px',
									}}>
									{/*<span className='text-muted'>Search:</span>*/}
									<FormGroup>
										<CustomSearchInput
											width={
												windowWidth > 1024 && windowWidth < 1578
													? '300px'
													: '350px'
											}
											mobileWidth='100%'
											onSearch={(value) => {
												// const param = new URLSearchParams();
												// param.set('search', value);
												// navigate({
												// 	pathname: '/reports/appointments',
												// 	search: param.toString(),
												// });
												filtersearch(value);
											}}
											// clearTrigger={clearTrigger}
										/>
									</FormGroup>
								</CardActions>
							</>
						)}
					</div>
					{/* <CommonActionHeader
						preCount={PER_COUNT}
						perPage={perPage.toString()}
						onKeyUp={(value) => {
							filtersearch(value);
						}}
						onChange={(e) => {
							setPerPage(parseInt(e.target.value, 10));
							setCurrentPage(1);
							handlefunction(1, parseInt(e.target.value, 10));
						}}
					/> */}
				</CardHeader>
				<CardBody
					className='table-responsive'
					isScrollable={isFluid}
					style={{ paddingTop: '0' }}>
					<table className='table table-modern'>
						<thead>
							<tr
								style={{
									position: 'sticky',
									top: '0',
									backgroundColor: themeStatus === 'dark' ? '#141414' : '#e5e5e5',
									zIndex: 10,
								}}>
								<th>{t('ID')}</th>
								<th>{t('Name')}</th>
								<th>{t('Branch')}</th>
								<th>
									{t('Price')} ({promoc.currency})
								</th>
								<th>{t('Quantity')}</th>
								<th>{t('Status')}</th>
								<th>{t('Action')}</th>
							</tr>
						</thead>
						<tbody>
							{promo?.length > 0 ? (
								promo?.map((item, index) => (
									<tr key={item.id}>
										{/* <td>{item.user_code}</td> */}
										<td>{item.id}</td>
										<td>{item.name}</td>
										<td>{item.branch_name}</td>
										<td>{item.price}</td>
										<td>
											<div style={{ display: 'flex', alignItems: 'center' }}>
												{<span>{item.quantity}</span>}
												{/* {item.quantity > 0 && <span>{item.quantity}</span>} */}
												{item.quantity > 0 &&
													item.quantity <= item.min_quantity && (
														<div
															style={{
																display: 'flex',
																marginLeft: '10px',
															}}>
															<Popover
																isOpen={isPopoverOpenlow[index]}
																positions={['left']}
																content={
																	<div>
																		<span
																			style={{
																				backgroundColor:
																					'rgba(0, 0, 0, 0.85)',
																				borderRadius: '5px',
																				boxShadow:
																					'0 0 5px rgba(0, 0, 0, 0.4)',
																				color: '#fff',
																				fontSize: '12px',
																				fontFamily:
																					'Helvetica, sans-serif',
																				padding: '7px 18px',
																				zIndex: 4,
																			}}>
																			{t('Stock Running Low')}
																		</span>
																	</div>
																}>
																<div
																	onMouseEnter={() =>
																		setIsPopoverOpenlow(
																			(prev) => {
																				const temp = [
																					...prev,
																				];
																				temp[index] = true;
																				return temp;
																			},
																		)
																	}
																	onMouseLeave={() =>
																		setIsPopoverOpenlow(
																			(prev) => {
																				const temp = [
																					...prev,
																				];
																				temp[index] = false;
																				return temp;
																			},
																		)
																	}>
																	<Button
																		isOutline={!darkModeStatus}
																		color='dark'
																		isLight={darkModeStatus}
																		className={classNames(
																			'text-nowrap',
																			{
																				'border-light':
																					!darkModeStatus,
																			},
																		)}
																		icon='Warning'
																		style={{
																			background:
																				'transparent',
																			width: 'auto',
																			padding: '5px',
																		}}
																	/>
																</div>
															</Popover>
														</div>
													)}
												{item.quantity === 0 && (
													<div
														style={{
															display: 'flex',
															marginLeft: '10px',
														}}>
														<Popover
															isOpen={isPopoverOpenlow[index]}
															positions={['left']}
															content={
																<div>
																	<span
																		style={{
																			backgroundColor:
																				'rgba(0, 0, 0, 0.85)',
																			borderRadius: '5px',
																			boxShadow:
																				'0 0 5px rgba(0, 0, 0, 0.4)',
																			color: '#fff',
																			fontSize: '12px',
																			fontFamily:
																				'Helvetica, sans-serif',
																			padding: '7px 18px',
																			zIndex: 4,
																		}}>
																		{t('Out Of Stock')}
																	</span>
																</div>
															}>
															<div
																onMouseEnter={() =>
																	setIsPopoverOpenlow((prev) => {
																		const temp = [...prev];
																		temp[index] = true;
																		return temp;
																	})
																}
																onMouseLeave={() =>
																	setIsPopoverOpenlow((prev) => {
																		const temp = [...prev];
																		temp[index] = false;
																		return temp;
																	})
																}>
																<Button
																	isOutline={!darkModeStatus}
																	color='dark'
																	isLight={darkModeStatus}
																	className={classNames(
																		'text-nowrap',
																		{
																			'border-light':
																				!darkModeStatus,
																		},
																	)}
																	icon='IndeterminateCheckBox'
																	style={{
																		background: 'transparent',
																		width: 'auto',
																		padding: '5px',
																	}}
																/>
																{/* <Icon
																	style={{ color: 'danger' }}
																	icon='DisabledByDefault'
																	size='2x'
																/> */}
															</div>
														</Popover>
													</div>
												)}
											</div>
										</td>

										<td>
											{item.status === 1 ? (
												<Icon icon='Done Outline' color='success' />
											) : (
												<Icon icon='DoDisturb' color='danger' />
											)}
										</td>
										<td>
											<div style={{ display: 'flex' }}>
												<div style={{ marginRight: '10px' }}>
													<Popover
														isOpen={isPopoverOpen[index]}
														positions={['left']}
														content={
															<div>
																<span
																	style={{
																		backgroundColor:
																			'rgba(0, 0, 0, 0.85)',
																		borderRadius: '5px',
																		bottom: '1px',
																		boxShadow:
																			'0 0 5px rgba(0, 0, 0, 0.4)',
																		color: '#fff',
																		fontSize: '12px',
																		fontFamily:
																			'Helvetica, sans-serif',
																		left: '-45px',
																		padding: '7px 10px',
																		position: 'absolute',
																		width: '48px',
																		zIndex: 4,
																	}}>
																	{t('Edit')}
																</span>
															</div>
														}>
														<div
															onMouseEnter={() =>
																setIsPopoverOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = true;
																	return temp;
																})
															}
															onMouseLeave={() =>
																setIsPopoverOpen((pre) => {
																	const temp = [...pre];
																	temp[index] = false;
																	return temp;
																})
															}>
															<Button
																isOutline={!darkModeStatus}
																color='dark'
																isLight={darkModeStatus}
																className={classNames(
																	'text-nowrap',
																	{
																		'border-light':
																			!darkModeStatus,
																	},
																)}
																icon='Edit'
																style={{
																	background: 'transparent',
																	width: 'auto',
																	padding: '5px',
																}}
																onClick={() =>
																	handleUpcomingEdit(item.id)
																}
															/>
														</div>
													</Popover>
												</div>
											</div>
										</td>
									</tr>
								))
							) : (
								<NoRecords />
							)}
						</tbody>
					</table>
				</CardBody>
				<PaginationButtons
					data={items}
					handlefunction={handlefunction}
					totalrows={totalRows}
					label={t('items')}
					setCurrentPage={setCurrentPage}
					currentPage={currentPage}
					perPage={perPage}
					setPerPage={setPerPage}
				/>
			</Card>

			<OffCanvas
				setOpen={setUpcomingEventsEditOffcanvas}
				isOpen={upcomingEventsEditOffcanvas}
				titleId='upcomingEdit'
				className='custom-offcanvas-width'
				//isBodyScroll
				placement='end'>
				<OffCanvasHeader
					setOpen={setUpcomingEventsEditOffcanvas}
					onHandle={() => {
						if (compresserRef.current) {
							compresserRef.current.abort();
							compresserRef.current = null;
						}
						setImgedittypeerror(false);
						resetUpload();
						setImgurl(null);
						setudetail({});
					}}>
					<OffCanvasTitle id='upcomingEdit'>{t('Edit Product')}</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<Card>
						{/* <CardHeader>
								<CardLabel icon='Photo' iconColor='info'>
									<CardTitle>Service Image</CardTitle>
								</CardLabel>
							</CardHeader> */}
						<CardBody>
							<div className='row'>
								<div className='col-12'>
									{udetail.filepath ? (
										<div
											className='mx-auto d-flex img-fluid mb-3'
											style={{
												borderRadius: '10px',
												overflow: 'hidden',
												width: 128,
												height: 128,
											}}>
											<img
												src={udetail.filepath}
												style={{
													objectFit: 'cover',
													width: '100%',
													height: '100%',
												}}
												alt=''
											/>
										</div>
									) : (
										<PlaceholderImage
											width={128}
											height={128}
											className='mx-auto d-block img-fluid mb-3 rounded'
										/>
									)}
									{(udetail.filepath === null ||
										udetail.filepath === undefined ||
										udetail.filepath === '') && (
										<p
											style={{
												color: 'red',
												fontSize: '12px',
												width: '100%',
												textAlign: 'center',
											}}>
											{t('*Required')}
										</p>
									)}
									{imgedittypeerror && (
										<p
											style={{
												color: 'red',
												fontSize: '12px',
												width: '100%',
												textAlign: 'center',
											}}>
											{t('*Allow Image Only')}
										</p>
									)}
									{progress.uploading && (
										<div
											class='progress'
											style={{
												height: '5px',
												marginBottom: '15px',
											}}>
											<div
												class='progress-bar progress-bar-striped progress-bar-animated'
												role='progressbar'
												aria-valuenow='75'
												aria-valuemin='0'
												aria-valuemax='100'
												style={{
													width: `${progress.progress}%`,
												}}></div>
										</div>
									)}
								</div>
								<div className='col-12'>
									<div className='row g-4'>
										<div className='col-12'>
											<Input
												ref={inputFile}
												type='file'
												id='filepath'
												accept='image/*'
												autoComplete='photo'
												onChange={(e) => {
													if (e.target.files.length > 0) {
														if (
															`${e.target.files[0].type}`.split(
																'/',
															)[0] === 'image'
														) {
															setImgedittypeerror(false);
															const reader = new FileReader();
															reader.addEventListener('load', () => {
																// setImgurlup(reader.result);
																setudetail((pre) => {
																	const temp = {
																		...pre,
																		filepath: reader.result,
																	};
																	return temp;
																});
																setImgurl(reader.result);
																//
															});
															reader.readAsDataURL(e.target.files[0]);
															setImgFile(e.target.files[0]);
															//setFilepath(e.target.files);
															setEditCropperModalOpen(true);

															//phpempUp(e.target.files);
														} else {
															// setImgurlup('');
															setudetail((pre) => {
																const temp = {
																	...pre,
																	filepath: '',
																};
																return temp;
															});
															setImgurl(null);
															handleReset();
															setImgedittypeerror(true);
														}
													}
													//
												}}
												// onClick={}
											/>
											{/* {} */}
										</div>
										{/* <div className='col-12'>
											<Button
												color='dark'
												isLight
												icon='Delete'
												className='w-100'
												onClick={() => {
													setEditItems({ ...editItems, image: null });
													// setSelectedImagen("")
													setudetail((pre) => {
														const temp = {
															...pre,
															filepath: undefined,
														};
														return temp;
													});
													setImgurlup('');
													setEditItems((pre) => {
														const temp = { ...pre, id: null };
														return temp;
													});
												}}>
												Delete Image
											</Button>
										</div> */}
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
					<div className='row g-4'>
						<div className='col-6'>
							<FormGroup id='upname' label={t('Product Name')}>
								<Input
									style={{
										border: updateemployeeerror.name.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateemployeeerror.name.error) {
											setUpdateemployeeerror((pre) => {
												const temp = {
													...pre,
													name: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												name: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.name}
								/>
							</FormGroup>
							{updateemployeeerror.name.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.name.msg
										? updateemployeeerror.name.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='Proprice' label={t('Price')}>
								<Input
									style={{
										border: updateemployeeerror.price.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateemployeeerror.price.error) {
											setUpdateemployeeerror((pre) => {
												const temp = {
													...pre,
													price: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												price: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.price}
								/>
							</FormGroup>
							{updateemployeeerror.price.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.price.msg
										? updateemployeeerror.price.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-6'>
							<FormGroup id='upshow' label={t('Show Customer')}>
								<Select
									placeholder={`${t('Choose')}...`}
									list={[
										{ value: '1', text: t('View') },
										{ value: '0', text: t('Hide') },
									]}
									// style={{
									// 	border: updateemployeeerror.show_customer.error
									// 		? '2px solid red'
									// 		: '2px solid transparent',
									// }}
									onChange={(e) => {
										setudetail((pre) => {
											const temp = {
												...pre,
												show_customer: e.target.value,
											};
											return temp;
										});
										// if (updateemployeeerror.show_customer.error) {
										// 	setUpdateemployeeerror((pre) => {
										// 		const temp = {
										// 			...pre,
										// 			show_customer: {
										// 				error: false,
										// 				msg: t('*Required'),
										// 			},
										// 		};
										// 		return temp;
										// 	});
										// }
									}}
									value={udetail.show_customer}
								/>
							</FormGroup>
							{/* {updateemployeeerror.show_customer.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.show_customer.msg
										? updateemployeeerror.show_customer.msg
										: t('*Required')}
								</p>
							)} */}
						</div>
						<div className='col-6'>
							<FormGroup id='ustatus' label={t('Status')}>
								<Select
									placeholder='Choose...'
									list={[
										{ value: '1', text: t('Active') },
										{ value: '0', text: t('Inactive') },
									]}
									onChange={(e) => {
										e.preventDefault();
										// setUpcomingEventsEditOffcanvas(
										// 	!upcomingEventsEditOffcanvas,
										// );
										startmodel2();
										setudetail((pre) => {
											const temp = {
												...pre,
												status: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.status}
								/>
							</FormGroup>
						</div>
						<div className='col-12'>
							<FormGroup id='udcp' label={t('Description')}>
								<Textarea
									style={{
										border: updateemployeeerror.description.error
											? '2px solid red'
											: '2px solid transparent',
										minHeight: '70px',
										height: '80px',
									}}
									maxLength={500}
									onChange={(e) => {
										const value = e.target.value;

										// Check if the input exceeds 250 characters
										if (value.length > 500) {
											// Set an error message if it exceeds the limit
											setUpdateemployeeerror((pre) => ({
												...pre,
												description: {
													error: true,
													msg: t(
														'Description cannot exceed 500 characters',
													),
												},
											}));
										} else {
											// Clear error if it was previously set and update state
											if (updateemployeeerror.description.error) {
												setUpdateemployeeerror((pre) => ({
													...pre,
													description: {
														error: false,
														msg: t('*Required'),
													},
												}));
											}

											// Update the state with the new value
											setudetail((pre) => ({
												...pre,
												description: value,
											}));
										}
									}}
									value={udetail.description}
								/>
							</FormGroup>

							{updateemployeeerror.description.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.description.msg
										? updateemployeeerror.description.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-12'>
							<FormGroup>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignContent: 'center',
										gap: 17,
									}}>
									<Label>{t('Branches')}</Label>
									<ChecksGroup
										onChange={(e) => {
											setSelectalle((pre) => {
												const tepmarray = { ...pre };
												tepmarray.checked = tepmarray.checked
													? false
													: true;
												return tepmarray;
											});
											if (e.target.checked) {
												setBranchess((p) =>
													p.map((r) => ({
														...r,
														checked: true,
														qty: '',
														minqty: '',
													})),
												);
											} else {
												setBranchess((p) =>
													p.map((r) => ({
														...r,
														checked: false,
														qty: '',
														minqty: '',
													})),
												);
											}
										}}>
										<Checks
											label={selectalle.label}
											checked={selectalle.checked}
										/>
									</ChecksGroup>
								</div>
								<ChecksGroup
									onChange={(e) => {
										if (e.target.type !== 'checkbox') return;
										setBranches((pre) => {
											const updatedArray = [...pre];
											let index;
											updatedArray.forEach((b, i) => {
												if (b.id === Number(e.target.id)) {
													index = i;
												}
											});
											if (index !== undefined) {
												updatedArray[index].checked = e.target.checked;
											}

											return updatedArray;
										});
									}}>
									<table>
										<thead>
											<tr>
												<th>{t('')}</th>
												<th>{t('Quantity')}</th>
												<th>{t('Minimum Quantity')}</th>
											</tr>
										</thead>
										<tbody>
											{branchess?.map(
												({ id, label, checked, qty, minqty }, i) => (
													<tr key={id}>
														<td className='branch_w'>
															<Checks
																key={id}
																id={id}
																label={`${label}`}
																checked={checked}
																onChange={(e) => {
																	setBranchess((t) => {
																		const temp = [...t];
																		const index =
																			temp.findIndex((d) => {
																				return d.id == id;
																			});
																		temp[index] = {
																			...temp[index],
																			// checked: !checked,
																			checked: e.target
																				.checked
																				? 1
																				: 0,
																		};

																		return temp;
																	});
																}}
															/>
														</td>
														<td>
															<Input
																// placeholder={t('Quantity')}
																className='check_input'
																style={{
																	width: '190px',
																	border: upcheckinputerror[id]
																		?.errorMessage
																		? '2px solid red'
																		: '2px solid transparent',
																}}
																value={qty}
																disabled={!checked}
																onChange={(e) => {
																	setBranchess((p) => {
																		const temp = [...p];
																		temp[i].qty =
																			e.target.value;
																		return temp;
																	});
																}}
															/>
															{upcheckinputerror[id]
																?.errorMessage && (
																<p
																	style={{
																		color: 'red',
																		fontSize: '12px',
																	}}>
																	{' '}
																	{upcheckinputerror[id]
																		?.errorMessage
																		? upcheckinputerror[id]
																				?.errorMessage
																		: t('*Required')}
																</p>
															)}
														</td>
														<td>
															<Input
																// placeholder={t('Minimum Quantity')}
																className='check_input'
																style={{
																	width: '190px',
																	border: upcheckinputerror[id]
																		?.errorMessage
																		? '2px solid red'
																		: '2px solid transparent',
																}}
																value={minqty}
																disabled={!checked}
																onChange={(e) => {
																	setBranchess((p) => {
																		const temp = [...p];
																		temp[i].minqty =
																			e.target.value;
																		return temp;
																	});
																}}
															/>
															{upcheckinputerror[id]
																?.errorMessage && (
																<p
																	style={{
																		color: 'red',
																		fontSize: '12px',
																	}}>
																	{' '}
																	{upcheckinputerror[id]
																		?.errorMessage
																		? upcheckinputerror[id]
																				?.errorMessage
																		: t('*Required')}
																</p>
															)}
														</td>
													</tr>
												),
											)}
										</tbody>
									</table>
								</ChecksGroup>
							</FormGroup>
						</div>
						{/* <div className='col-12'>
							<FormGroup id='Quantity' label={t('Quantity')}>
								<Input
									style={{
										border: updateemployeeerror.quantity.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateemployeeerror.quantity.error) {
											setUpdateemployeeerror((pre) => {
												const temp = {
													...pre,
													quantity: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												quantity: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.quantity}
								/>
							</FormGroup>
							{updateemployeeerror.quantity.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.quantity.msg
										? updateemployeeerror.quantity.msg
										: t('*Required')}
								</p>
							)}
						</div>
						<div className='col-12'>
							<FormGroup id='minqty' label={t('Minimum Quantity')}>
								<Input
									style={{
										border: updateemployeeerror.min_quantity.error
											? '2px solid red'
											: '2px solid transparent',
									}}
									onChange={(e) => {
										if (updateemployeeerror.min_quantity.error) {
											setUpdateemployeeerror((pre) => {
												const temp = {
													...pre,
													min_quantity: {
														error: false,
														msg: t('*Required'),
													},
												};
												return temp;
											});
										}
										setudetail((pre) => {
											const temp = {
												...pre,
												min_quantity: e.target.value,
											};
											return temp;
										});
									}}
									value={udetail.min_quantity}
								/>
							</FormGroup>
							{updateemployeeerror.min_quantity.error && (
								<p
									style={{
										color: 'red',
										fontSize: '12px',
									}}>
									{' '}
									{updateemployeeerror.min_quantity.msg
										? updateemployeeerror.min_quantity.msg
										: t('*Required')}
								</p>
							)}
						</div> */}
					</div>
					{isTab && (
						<div className='col-12 p-3'>
							<Button
								color='info'
								className='w-100'
								onClick={updateproduct}
								disabled={isLoading}>
								{t('Update')}
							</Button>
						</div>
					)}
				</OffCanvasBody>
				{!isTab && (
					<div className='col-12 p-3'>
						<Button
							color='info'
							className='w-100'
							onClick={updateproduct}
							disabled={isLoading}>
							{t('Update')}
						</Button>
					</div>
				)}
			</OffCanvas>

			<OffCanvas
				setOpen={setUpcomingEventsInfoOffcanvasss}
				onHandle={() => togglePasswordVisibilitynew(false)}
				isOpen={upcomingEventsInfoOffcanvasss}
				titleId='upcomingDetails'
				className='custom-offcanvas-width'
				placement='end'>
				<OffCanvasHeader
					setOpen={setUpcomingEventsInfoOffcanvasss}
					onHandle={() => {
						if (compresserRef.current) {
							compresserRef.current.abort();
							compresserRef.current = null;
						}
						setImgtypeerror(false);
						resetUpload();
						setImgurl(null);
					}}>
					{/* dgdgd */}
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='row'>
						{/* <div className='col-md-6' Style='width: 600px'>
							<Card className='rounded-1 mb-0'>
								<CardHeader>
									<CardLabel icon='ReceiptLong'>
										<CardTitle>New Category</CardTitle>
									</CardLabel>
								</CardHeader>
								<CardBody>
									<div className='row g-3'>
										<FormGroup
											id='streetAddress'
											label='Category Name'
											className='col-12'>
											<Input
												id='catname'
												onChange={(e) => setCatname(e.target.value)}
												value={formik.values.streetAddress}
											/>
										</FormGroup>

										<Button color='info' onClick={insertCategory}>
											Save
										</Button>
									</div>
								</CardBody>
							</Card>
						</div> */}
						<br />
						<div className='col-md-6' Style='width: 800px'>
							<Card className='rounded-1 mb-0'>
								<CardHeader>
									<CardLabel icon='PostAdd'>
										<CardTitle>{t('Add New Product')}</CardTitle>
									</CardLabel>
								</CardHeader>
								<CardBody className='pt-0'>
									<Card>
										{/* <CardHeader>
								<CardLabel icon='Photo' iconColor='info'>
									<CardTitle>Service Image</CardTitle>
								</CardLabel>
							</CardHeader> */}
										<CardBody>
											<div className='row'>
												<div className='col-12'>
													{imgurl ? (
														<div
															className='mx-auto d-flex img-fluid mb-3'
															style={{
																borderRadius: '10px',
																overflow: 'hidden',
																width: 128,
																height: 128,
															}}>
															<img
																src={imgurl}
																style={{
																	objectFit: 'cover',
																	width: '100%',
																	height: '100%',
																}}
																alt=''
															/>
														</div>
													) : (
														<PlaceholderImage
															width={128}
															height={128}
															className='mx-auto d-block img-fluid mb-3 rounded'
														/>
													)}

													{progress.uploading && (
														<div
															class='progress'
															style={{
																height: '5px',
																marginBottom: '15px',
															}}>
															<div
																class='progress-bar progress-bar-striped progress-bar-animated'
																role='progressbar'
																aria-valuenow='75'
																aria-valuemin='0'
																aria-valuemax='100'
																style={{
																	width: `${progress.progress}%`,
																}}></div>
														</div>
													)}
													{(imgurl === null || imgurl === undefined) && (
														<p
															style={{
																color: 'red',
																fontSize: '12px',
																width: '100%',
																textAlign: 'center',
															}}>
															{t('*Required')}
														</p>
													)}
													{imgtypeerror && (
														<p
															style={{
																color: 'red',
																fontSize: '12px',
																width: '100%',
																textAlign: 'center',
															}}>
															{t('*Allow Image Only')}
														</p>
													)}
												</div>
												<div className='col-12'>
													<div className='row g-4'>
														<div className='col-12'>
															<Input
																type='file'
																ref={inputFile}
																id='filepath'
																autoComplete='photo'
																accept='image/*'
																onChange={(e) => {
																	if (e.target.files.length > 0) {
																		if (
																			`${e.target.files[0].type}`.split(
																				'/',
																			)[0] === 'image'
																		) {
																			setImgtypeerror(false);
																			const reader =
																				new FileReader();
																			reader.addEventListener(
																				'load',
																				() => {
																					setImgurl(
																						reader.result,
																					);
																					//
																				},
																			);
																			reader.readAsDataURL(
																				e.target.files[0],
																			);
																			setImgFile(
																				e.target.files[0],
																			);
																			//setFilepath(e.target.files);
																			//phpUp(e.target.files);
																			setCropperModalOpen(
																				true,
																			);
																			//
																		} else {
																			setImgurl(null);
																			setImgFile(null);
																			setImgtypeerror(true);
																		}
																	}
																}}
															/>
															{/* {} */}
														</div>
														{/* <div className='col-12'>
															<Button
																color='dark'
																isLight
																icon='Delete'
																className='w-100'
																onClick={() => {
																	setEditItems({
																		...editItems,
																		image: null,
																	});
																	// setSelectedImagen("")
																	setImgurl(null);
																	setEditItems((pre) => {
																		const temp = {
																			...pre,
																			id: null,
																		};
																		return temp;
																	});
																}}>
																Delete Image
															</Button>
														</div> */}
													</div>
												</div>
											</div>
										</CardBody>
									</Card>
									<div className='row g-3'>
										<FormGroup
											id='npname'
											label={t('Product Name')}
											className='col-12'>
											<Input
												type='text'
												value={newemp.Name}
												style={{
													border: newemperror.Name.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												onChange={(e) => {
													if (newemperror.Name.error) {
														setNewemperror((pre) => {
															const temp = {
																...pre,
																Name: {
																	error: false,
																	msg: t('*Required'),
																},
															};
															return temp;
														});
													}
													setNewemp((pre) => {
														const temp = {
															...pre,
															Name: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{newemperror.Name.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Name.msg
													? newemperror.Name.msg
													: t('*Required')}
											</p>
										)}
										<FormGroup id='price' label={t('Price')} className='col-6'>
											<Input
												type='text'
												value={newemp.Proprice}
												style={{
													border: newemperror.Proprice.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												onChange={(e) => {
													if (newemperror.Proprice.error) {
														setNewemperror((pre) => {
															const temp = {
																...pre,
																Proprice: {
																	error: false,
																	msg: t('*Required'),
																},
															};
															return temp;
														});
													}
													setNewemp((pre) => {
														const temp = {
															...pre,
															Proprice: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{newemperror.Proprice.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Proprice.msg}
											</p>
										)}
										<FormGroup
											id='qty'
											label={t('Show Customer')}
											className='col-6'>
											<Select
												value={newemp.Show}
												style={{
													border: newemperror.Show.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												placeholder='Choose...'
												list={[
													{ value: '1', text: t('View') },
													{ value: '0', text: t('Hide') },
												]}
												onChange={(e) => {
													if (newemperror.Show.error) {
														setNewemperror((pre) => {
															const temp = {
																...pre,
																Show: {
																	error: false,
																	msg: t('*Required'),
																},
															};
															return temp;
														});
													}
													setNewemp((pre) => {
														const temp = {
															...pre,
															Show: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{newemperror.Show.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Show.msg
													? newemperror.Show.msg
													: t('*Required')}
											</p>
										)}
										{/* <div className=''>
											<Card className=' me-2'>
												<CardBody>
													<div
														className='col'
														style={{
															marginBottom: '1px',
														}}>
														<FormGroup
															id='aemp'
															label={t('Assign Employee')}>
															<Input
																type='text'
																value={newemp.Proprice}
															/>
														</FormGroup>
														<FormGroup
															id='aemp'
															label={t('Assign Employee')}>
															<Input
																type='text'
																value={newemp.Proprice}
															/>
														</FormGroup>
													</div>
													<div
														className='col'
														style={{
															display: 'flex',
															alignItems: 'center',
															marginTop: '30px',
															marginBottom: '5px',
														}}>
														<Button
															color='info'
															className='w-100'
															//onClick={upemp}
															//disabled={isLoading}
														>
															{t('Update')}
														</Button>
													</div>
												</CardBody>
											</Card>
										</div> */}
										{/* <FormGroup
											id='qty'
											label={t('Quantity')}
											className='col-12'>
											<Input
												type='text'
												value={newemp.Quantity}
												style={{
													border: newemperror.Quantity.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												onChange={(e) => {
													if (newemperror.Quantity.error) {
														setNewemperror((pre) => {
															const temp = {
																...pre,
																Quantity: {
																	error: false,
																	msg: t('*Required'),
																},
															};
															return temp;
														});
													}
													setNewemp((pre) => {
														const temp = {
															...pre,
															Quantity: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{newemperror.Quantity.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Quantity.msg
													? newemperror.Quantity.msg
													: t('*Required')}
											</p>
										)}
										<FormGroup
											id='mqty'
											label={t('Minimum Quantity')}
											className='col-12'>
											<Input
												type='text'
												value={newemp.Minquantity}
												style={{
													border: newemperror.Minquantity.error
														? '2px solid red'
														: '2px solid transparent',
												}}
												onChange={(e) => {
													if (newemperror.Minquantity.error) {
														setNewemperror((pre) => {
															const temp = {
																...pre,
																Minquantity: {
																	error: false,
																	msg: t('*Required'),
																},
															};
															return temp;
														});
													}
													setNewemp((pre) => {
														const temp = {
															...pre,
															Minquantity: e.target.value,
														};
														return temp;
													});
												}}
											/>
										</FormGroup>
										{newemperror.Minquantity.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Minquantity.msg
													? newemperror.Minquantity.msg
													: t('*Required')}
											</p>
										)} */}
										<FormGroup
											id='dcp'
											label={t('Description')}
											className='col-12'>
											<Textarea
												style={{
													border: newemperror.Note.error
														? '2px solid red'
														: '2px solid transparent',
													minHeight: '70px',
													height: '80px',
												}}
												value={newemp.Note}
												maxLength={500}
												onChange={(e) => {
													const value = e.target.value;
													if (value.length > 500) {
														setNewemperror((pre) => ({
															...pre,
															Note: {
																error: true,
																msg: t(
																	'Description cannot exceed 500 characters',
																),
															},
														}));
													} else {
														if (newemperror.Note.error) {
															setNewemperror((pre) => ({
																...pre,
																Note: {
																	error: false,
																	msg: t('*Required'),
																},
															}));
														}
														setNewemp((pre) => ({
															...pre,
															Note: value,
														}));
													}
												}}
											/>
										</FormGroup>

										{newemperror.Note.error && (
											<p
												style={{
													color: 'red',
													fontSize: '12px',
												}}>
												{' '}
												{newemperror.Note.msg
													? newemperror.Note.msg
													: t('*Required')}
											</p>
										)}
										<div className='col-12'>
											<FormGroup>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														alignItems: 'center',
														gap: 17,
													}}>
													<Label>{t('Branches')}</Label>
													<ChecksGroup
														onChange={(e) => {
															setSelectall((pre) => {
																const tepmarray = { ...pre };
																tepmarray.checked =
																	tepmarray.checked
																		? false
																		: true;
																return tepmarray;
															});
															if (e.target.checked) {
																setBranches((p) =>
																	p.map((r) => ({
																		...r,
																		checked: true,
																		qty: '',
																		minqty: '',
																	})),
																);
															} else {
																setBranches((p) =>
																	p.map((r) => ({
																		...r,
																		checked: false,
																		qty: '',
																		minqty: '',
																	})),
																);
															}
														}}>
														<Checks
															label={selectall.label}
															checked={selectall.checked}
														/>
													</ChecksGroup>
												</div>

												<ChecksGroup
													onChange={(e) => {
														if (e.target.type !== 'checkbox') return;
														setBranches((pre) => {
															const tepmarray = [...pre];
															let index;
															tepmarray.forEach((b, i) => {
																if (b.id === Number(e.target.id)) {
																	index = i;
																}
															});
															if (index !== undefined) {
																tepmarray[index].checked =
																	e.target.checked;
															}

															return tepmarray;
														});
													}}>
													<table>
														<thead>
															<tr>
																<th>{t('')}</th>
																<th>{t('Quantity')}</th>
																<th>{t('Minimum Quantity')}</th>
															</tr>
														</thead>
														<tbody>
															{branches?.map(
																(
																	{
																		id,
																		label,
																		checked,
																		qty,
																		minqty,
																	},
																	i,
																) => (
																	<tr key={id}>
																		<td className='branch_w'>
																			<Checks
																				id={id}
																				label={`${label}`}
																				checked={checked}
																			/>
																		</td>
																		<td>
																			<Input
																				// placeholder={t(
																				// 	'Quantity',
																				// )}
																				className='check_input'
																				style={{
																					width: '175px',
																					border: newcheckinputerror[
																						id
																					]?.errorMessage
																						? '2px solid red'
																						: '2px solid transparent',
																				}}
																				value={qty}
																				disabled={!checked}
																				onChange={(e) => {
																					setBranches(
																						(p) => {
																							const temp =
																								[
																									...p,
																								];
																							temp[
																								i
																							].qty =
																								e.target.value;
																							return temp;
																						},
																					);
																				}}
																			/>
																		</td>
																		<td>
																			<Input
																				// placeholder={t(
																				// 	'Minimum Quantity',
																				// )}
																				className='check_input qty_w'
																				style={{
																					width: '175px',
																					border: newcheckinputerror[
																						id
																					]?.errorMessage
																						? '2px solid red'
																						: '2px solid transparent',
																				}}
																				value={minqty}
																				disabled={!checked}
																				onChange={(e) => {
																					setBranches(
																						(p) => {
																							const temp =
																								[
																									...p,
																								];
																							temp[
																								i
																							].minqty =
																								e.target.value;
																							return temp;
																						},
																					);
																				}}
																			/>
																		</td>
																	</tr>
																),
															)}
														</tbody>
													</table>
												</ChecksGroup>
												{/* <ChecksGroup
													onChange={(e) => {
														if (e.target.type !== 'checkbox') return;
														setBranches((pre) => {
															const tempArray = [...pre];
															let index;
															tempArray.forEach((b, i) => {
																if (b.id === Number(e.target.id)) {
																	index = i;
																}
															});
															if (index !== undefined) {
																tempArray[index].checked =
																	e.target.checked;
															}
															return tempArray;
														});
													}}>
													<table>
														<tbody>
															{branches?.map(
																(
																	{
																		id,
																		label,
																		checked,
																		qty,
																		minqty,
																	},
																	i,
																) => (
																	<React.Fragment key={id}>
																		<tr>
																			<td colSpan={2}>
																				<Checks
																					id={id}
																					label={label}
																					checked={
																						checked
																					}
																				/>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<Input
																					placeholder={t(
																						'Quantity',
																					)}
																					className='check_input'
																					style={{
																						border: newcheckinputerror[
																							id
																						]
																							?.errorMessage
																							? '2px solid red'
																							: '2px solid transparent',
																					}}
																					value={qty}
																					disabled={
																						!checked
																					}
																					onChange={(
																						e,
																					) => {
																						setBranches(
																							(p) => {
																								const temp =
																									[
																										...p,
																									];
																								temp[
																									i
																								].qty =
																									e.target.value;
																								return temp;
																							},
																						);
																					}}
																				/>
																			</td>
																			<td>
																				<Input
																					placeholder={t(
																						'Minimum Quantity',
																					)}
																					className='check_input'
																					style={{
																						border: newcheckinputerror[
																							id
																						]
																							?.errorMessage
																							? '2px solid red'
																							: '2px solid transparent',
																					}}
																					value={minqty}
																					disabled={
																						!checked
																					}
																					onChange={(
																						e,
																					) => {
																						setBranches(
																							(p) => {
																								const temp =
																									[
																										...p,
																									];
																								temp[
																									i
																								].minqty =
																									e.target.value;
																								return temp;
																							},
																						);
																					}}
																				/>
																			</td>
																		</tr>
																	</React.Fragment>
																),
															)}
														</tbody>
													</table>
												</ChecksGroup> */}
											</FormGroup>
										</div>
										<Button
											color='info'
											onClick={insertProduct}
											disabled={isLoading}>
											{t('Save')}
										</Button>
									</div>
								</CardBody>
							</Card>
						</div>
					</div>
				</OffCanvasBody>
			</OffCanvas>
		</>
	);
};

export default CommonProductList;
